/**
 */
define('constant/mysettings/team.member.constant',[], function () {

    return {
        ///0草稿 1邀请中 2邀请过期 3,生效中 4.已失效
        statusType: {
            '0': '草稿',
            '1': '邀请中',
            '2': '邀请失败',
            '3': '已激活',
            '4': '已失效'
        },
        //团队角色类型0.团队帐号1.管理员 2.开发 3.运营4.客服 5.财务  9.自定义
        roleType: {
            'Main': '团队帐号',
            'Admin': '管理员',
            'Developer': '开发',
            'Operator': '运营',
            'CustomerService': '客服',
            'Accountant': '财务',
            'SelfDefined': '自定义'
        }

    }
});

